import { IBuildingDetails, IFloorDetails, IPortfolioCity, IPortfolioRegion } from '@api'
import { isEmpty } from 'lodash'

const filterRegionsByString = (regions: IPortfolioRegion[], searchQuery: string) => {
  const hasBuildingMatched = makeHasBuildingMatched(searchQuery)
  const hasFloorMatched = makeHasFloorMatched(searchQuery)

  return regions.reduce<IPortfolioRegion[]>((accRegions, regionItem) => {
    const cities = regionItem.cities.reduce<IPortfolioCity[]>((accCities, cityItem) => {
      const buildings = getBuildings(cityItem, hasBuildingMatched, hasFloorMatched)

      if (isEmpty(buildings)) {
        return accCities
      }

      return [...accCities, { ...cityItem, buildings }]
    }, [])

    if (isEmpty(cities)) {
      return accRegions
    }

    return [...accRegions, { ...regionItem, cities }]
  }, [])
}

const getBuildings = (
  cityItem: IPortfolioCity,
  hasBuildingMatched: (buildingsItem: IBuildingDetails) => boolean,
  hasFloorMatched: (floorItem: IFloorDetails) => boolean
) =>
  cityItem.buildings.reduce<IBuildingDetails[]>((accBuildings, buildingsItem) => {
    if (!buildingsItem.floors && hasBuildingMatched(buildingsItem)) {
      return [...accBuildings, buildingsItem]
    }

    const floors = getFloors(buildingsItem, hasFloorMatched)

    if (isEmpty(floors)) {
      return accBuildings
    }

    return [...accBuildings, { ...buildingsItem, floors }]
  }, [])

const getFloors = (
  buildingsItem: IBuildingDetails,
  hasFloorMatched: (floorItem: IFloorDetails) => boolean
) =>
  buildingsItem.floors?.reduce<IFloorDetails[]>((accFloors, floorItem) => {
    if (hasFloorMatched(floorItem)) {
      return [...accFloors, floorItem]
    }

    return accFloors
  }, []) || []

const makeHasBuildingMatched =
  (searchQuery: string) =>
  (buildingsItem: IBuildingDetails): boolean =>
    buildingsItem.name?.toLocaleLowerCase().includes(searchQuery) ||
    buildingsItem.city?.toLocaleLowerCase().includes(searchQuery) ||
    buildingsItem.state?.toLocaleLowerCase().includes(searchQuery)

const makeHasFloorMatched =
  (searchQuery: string) =>
  (floorItem: IFloorDetails): boolean =>
    floorItem.name?.toLocaleLowerCase().includes(searchQuery) ||
    floorItem.building.city?.toLocaleLowerCase().includes(searchQuery) ||
    floorItem.building.state?.toLocaleLowerCase().includes(searchQuery) ||
    floorItem.building.name?.toLocaleLowerCase().includes(searchQuery)

export default filterRegionsByString
